
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { TypeaheadOptions } from 'ngx-bootstrap';

@Injectable()
export class RoomService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

    list(query?: any) {
        return this.get('/rooms',query);
    }

    create(body: any) {
        return this.post('/room',body);
    }

    find(id) {
        return this.get('/room/'+id);
    }

    update(id, body) {
        return this.put('/room/'+id, body);
    }

    allRoom() {
        return this.get('/all-room');
    }

    _delete(id) {
        return this.delete('/room/'+id);
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Room.service.ts